import { useTranslations } from "next-intl";
import { useRouter } from "@lib/i18n/navigation-pages-router";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import Button from "@components/core/Button";
import ClosetItemsList from "@components/core/ClosetItemsList";
import ClosetRTCFillingProgress from "./Elements/ClosetRTCFillingProgress";
import ClosetRTCFillingAddOn from "./Elements/ClosetRTCFillingAddOn";

function DrawerClosetRTCChangeStep({ setStep }) {
  const t = useTranslations("common");

  const router = useRouter();
  const currentCloset = useCustomizableCloset();

  function goToCatalog() {
    router.push("/catalogue");
  }

  function goToNextStep() {
    setStep("closetValidation");
  }

  return [
    <div
      className="drawer-body"
      key="drawer-rtc-change-body"
    >
      <ClosetRTCFillingProgress setStep={setStep} />

      <div className="d-flex flex-column p-2 gap-2">
        <ClosetRTCFillingAddOn />

        <ClosetItemsList closet={currentCloset} />
      </div>
    </div>,
    <div
      className="bg-white p-3 border-top border-light"
      key="drawer-rtc-change-footer"
    >
      {currentCloset.ready_to_pack_status.reason === "too_few_selected_items" ? (
        <Button
          fullWidth
          onClick={goToCatalog}
        >
          {t("drawer.modal_rtc.change.add_items_btn")}
        </Button>
      ) : (
        <Button
          fullWidth
          onClick={goToNextStep}
        >
          {t("drawer.modal_rtc.change.next_step_btn")}
        </Button>
      )}
    </div>,
  ];
}

export default DrawerClosetRTCChangeStep;
